<template>
  <div class="chat-message__footer" :class="{ right: !!chat.user }">
    <div v-if="operatorName && !chat.user">
      {{ operatorName }}
    </div>

    <time :datetime="chat.published_at">{{ formatTime(chat.published_at, 12) }}</time>

    <ul v-if="showEvaluation" class="chat-message__reactions" aria-hidden="true">
      <li :class="yesClass" @click="sendEval(chat, 'yes')"></li>
      <li :class="noClass" @click="sendEval(chat, 'no')"></li>
    </ul>
  </div>
</template>

<script>
import { formatTime } from 'Utilities'
import { Chat } from 'src/apis'
import { useAppStore } from 'Store/app'

export default {
  name: 'ChatMessageFooter',
  setup() {
    return {
      appStore: useAppStore()
    }
  },
  props: {
    chat: { type: Object, required: true },
    operatorName: { type: String, default: null }
  },
  data() {
    return {
      formatTime,
      showEvaluation: this.chat.concierge && this.chat.evaluate,
      evaluatedValue: this.chat.evaluate
    }
  },
  computed: {
    yesClass() {
      let classes = this.evaluatedValue === 'yes' ? 'clicked disabled' : ''
      return this.appStore.isFullScreen ? (classes += ' full-screen') : classes
    },
    noClass() {
      let classes = this.evaluatedValue === 'no' ? 'clicked disabled' : ''
      return this.appStore.isFullScreen ? (classes += ' full-screen') : classes
    }
  },

  methods: {
    sendEval(chat, value) {
      if (!this.showEvaluation) return
      this.evaluatedValue = this.evaluatedValue === value ? 'none' : value

      if (this.evaluatedValue !== 'none') {
        Chat.SendChatEval(chat.id, this.evaluatedValue).catch(console.error)
      }
    }
  }
}
</script>
